import React from 'react';
import * as Ui from './styles';

export function CardMinzd({
  // título
  title,
  // propaga o evento de acionamento do botão de restaurar
  onRestore,
}) {
  function handleClick() {
    if (onRestore) onRestore();
  }

  return (
    <Ui.Container>
      <Ui.Title>{title}</Ui.Title>
      <Ui.Action onClick={handleClick}>
        <Ui.ActionText>{'Minimizado'}</Ui.ActionText>
        <Ui.ActionIcon size={18} />
      </Ui.Action>
    </Ui.Container>
  );
}
